import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAdminContext } from "../context/admin/AdminContext";

const RequireAuth: React.FC = () => {
  const { sysAdmin } = useAdminContext();
  const location = useLocation();

  if (!sysAdmin) {
    return (
      <Navigate
        replace
        to="/login"
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <Outlet />;
};

export default RequireAuth;
